
import 'pages/orders/orders-list.tag'
import 'pages/orders/order-edit.tag'
import 'pages/orders/orders-list-paid.tag'
import 'pages/orders/stock-list.tag'
import 'pages/orders/stock-edit.tag'
import 'pages/orders/orders-list-check.tag'
import 'pages/orders/orders-list-sent.tag'
import 'pages/orders/orders-list-archive.tag'
import 'pages/orders/warehouse-list.tag'
import 'pages/orders/sales-list.tag'
riot.tag2('orders', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: link == tab}" each="{tabs}" if="{checkPermission(permission, 1000)}"><a href="#orders/{link}"><span>{title}</span>&nbsp;<span class="badge" if="{isCount}">{count}</span></a></li>\n  </ul>\n  <div class="column">\n    <orders-list if="{tab == &quot;new&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-new&quot;, 1000)}"></orders-list>\n    <orders-list-paid if="{tab == &quot;paid&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-paid&quot;, 1000)}"></orders-list-paid>\n    <stock-list if="{tab == &quot;stock&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-stock&quot;, 1000)}"></stock-list>\n    <orders-list-check if="{tab == &quot;check&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-check&quot;, 1000)}"></orders-list-check>\n    <orders-list-sent if="{tab == &quot;sent&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-sent&quot;, 1000)}"></orders-list-sent>\n    <orders-list-archive if="{tab == &quot;archive&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-archive&quot;, 1000)}"></orders-list-archive>\n    <warehouse-list if="{tab == &quot;warehouse&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-archive&quot;, 1000)}"></warehouse-list>\n    <sales-list if="{tab == &quot;sales&quot; &amp;&amp; !edit &amp;&amp; checkPermission(&quot;orders-archive&quot;, 1000)}"></sales-list>\n    <order-edit if="{tab == &quot;&quot; &amp;&amp; edit}"></order-edit>\n    <stock-edit if="{tab == &quot;stock&quot; &amp;&amp; edit}"></stock-edit>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');

self.tab = '';

self.tabs = [{ title: 'Новые', name: 'orders', link: 'new', tag: 'orders-list', count: 0, permission: 'orders-new', isCount: true }, { title: 'Оплаченные', name: 'paid', link: 'paid', tag: 'orders-list-paid', count: 0, permission: 'orders-paid' }, { title: 'Склад', name: 'stock', link: 'stock', tag: 'stock-list', count: 0, permission: 'stock' }, { title: 'На проверке', name: 'check', link: 'check', tag: 'orders-list-check', count: 0, permission: 'orders-check', isCount: true }, { title: 'Отправленные', name: 'sent', link: 'sent', tag: 'orders-list-sent', count: 0, permission: 'orders-sent' }, { title: 'Архив', name: 'archive', link: 'archive', tag: 'orders-list-archive', count: 0, permission: 'orders-archive' }, { title: 'Склад товара', name: 'warehouse', link: 'warehouse', tag: 'warehouse-list', count: 0, permission: 'orders-archive' }, { title: 'Продажи', name: 'sales', link: 'sales', tag: 'sales-list', count: 0, permission: 'orders-archive' }];

self.edit = false;
self.notFound = false;

var route = riot.route.create();

route('/orders', function () {
    self.tabs.every(function (tab) {
        if (self.checkPermission(tab.permission, "1000")) {
            riot.route('/orders/' + tab.link);
            return false;
        }
        return true;
    });
});

route('/orders/([0-9]+)..', function (id) {
    observable.trigger('orders-edit', id);
    self.edit = true;
    self.notFound = false;
    self.tab = '';
    self.update();
});

route('/orders/add', function () {
    self.edit = true;
    self.notFound = false;
    self.tab = '';
    observable.trigger('order-new');
    self.update();
});

route('/orders/stock/([0-9]+)', function (id) {
    observable.trigger('stock-edit', id);
    self.edit = true;
    self.notFound = false;
    self.tab = 'stock';
    self.update();
});

route('/orders/*', function (tab) {
    var idx = self.tabs.map(function (i) {
        return i.link;
    }).indexOf(tab);
    if (idx !== -1 && self.checkPermission(self.tabs[idx].permission, "1000")) {
        var tag = self.tabs[idx].tag;
        if (self.tags[tag] && self.tags[tag].tags.catalog) self.tags[tag].tags.catalog.reload();
        self.update({ edit: false, tab: tab });
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/orders..', function () {
    self.notFound = true;
    self.tab = 'orders';
    self.update();
    observable.trigger('not-found');
});

observable.on('tabs-update', function (counts) {
    self.tabs.forEach(function (tab) {
        var name = tab.name;
        if (name && counts[name]) {
            tab.count = counts[name];
        }
    });
    self.update();
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/orders/orders.tag